import {ActionTypes, DataActionTypes} from './../../cc-imports'
import _ from 'lodash';

const initialState = {
    rewards: {
        rewards: {},
    },

    type : DataActionTypes.GET,
    completed : false,

    fetching: false,
    fetched: false,
    success: false,
    random : 0
};

const processData = (oldRewards, rewards)=>{
    const byId = _.keyBy(rewards, 'id');
    var existingRewardsByIds = oldRewards.rewards ? oldRewards.rewards : [];

    existingRewardsByIds = _.merge({}, existingRewardsByIds, byId);

    return {
        rewards : existingRewardsByIds
    }
};


const RewardReducers = (state = initialState, action = {}) => {

    switch (action.type) {
        case (ActionTypes.getCCFulfilled(ActionTypes.GET_REWARD)):
        case (ActionTypes.getCCFulfilled(ActionTypes.UPDATE_REWARD_CLAIM)):
            let reward = action.payload.data.item;
            return {
                ...state,
                fetching: false,
                fetched: true,
                rewards: processData(state.rewards,[reward]),
                success: true,
                type : action.meta.type,
                random:Math.random()
            }
            break;
        case (ActionTypes.getFulfilled(ActionTypes.GET_REWARD)):
        case (ActionTypes.getFulfilled(ActionTypes.UPDATE_REWARD_CLAIM)):
            return {
                ...state,
                uFetching: false,
                uFetched: true,
                uSuccess: false,
                completed: true,
                type : action.meta.type,
                random:Math.random()
            }
            break;
        case (ActionTypes.getPending(ActionTypes.GET_REWARD)):
        case (ActionTypes.getPending(ActionTypes.UPDATE_REWARD_CLAIM)):
            return {...state, fetching: true, type : action.meta.type}
            break;
        case (ActionTypes.getRejected(ActionTypes.GET_REWARD)):
        case (ActionTypes.getRejected(ActionTypes.UPDATE_REWARD_CLAIM)):
            return {...state, fetching: false, fetched: true, type : action.meta.type}
            break;


        default :
            return state;
    }
};

export default RewardReducers;



// WEBPACK FOOTER //
// ./src/app/data/reducers/RewardsReducers.js